// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scrollable-select .v-select__selections {\n  max-height: 100px;\n  overflow-y: auto;\n}\n.scrollable-select .v-menu__content {\n  max-height: 300px;\n  overflow-y: auto;\n}\n.scrollable-select .v-select__content {\n  max-height: 300px; /* Set max height for the dropdown content */\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
